import { store } from '@/store';

export default function canAccessJobRequestMiddleware({ next, router }) {
	let validToken = store.isTokenValid();
	if (validToken === false) {
		router.replace({ redirect: '/pages/404' });
	}
	next();
}
